var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.items,"item-text":"text","item-value":"value","disabled":""},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})}
var staticRenderFns = []

export { render, staticRenderFns }